import React, { useMemo, useState } from "react";
import PortIcon from "../../../assets/images/port-green.svg";
import { PortHookInterface } from "../portDetailsHook";
import Input from "./Input";
import WaveXchangeLogo from "../../../assets/images/wavexchange-logo-color.svg";
import WaveXchangeLogoSmall from "../../../assets/images/wavexchange-small-icon.svg";
import { areYouSure, toasterError, wrapInDrawer, wrapInTooltip } from "../../../utils/methods";
import Button from "../../DesignSystem/button";
import { useLogs } from "../logsHook";
import WaveXchangeButton from "./WaveXchangeButton";
import RollTrafficService from "../../../services/rollTraffic.service";
import { rollServiceType } from "../useRollService";

interface PortProps {
  portProps: PortHookInterface;
  rollService: rollServiceType;
  isBandwidth?: boolean;
}

export const ProviderView: React.FC<PortProps> = ({ portProps, rollService, isBandwidth }) => {
  const { candidateRolls, portDetails } = portProps;
  let fullName = "";
  if (portDetails) {
    const { port_name, port_description, bandwidth_description, bandwidth_name } = portDetails;
    if (isBandwidth) fullName = `${bandwidth_description} ${bandwidth_name}`;
    else fullName = `${port_description} ${port_name}`;
  }

  return (
    <div>
      <ol>
        {candidateRolls.map((candidate, index) => {
          return (
            <li key={index} className="flex">
              <img src={PortIcon} alt={"verified port"} />
              <span>{candidate.name}</span>
              <Button
                loading={rollService.loading}
                onClick={() => areYouSure(() => rollService.rollService(candidate.id), `Roll service ${fullName} onto ${candidate.name}`)}
                variant="grouped"
                text="roll service"
              />
            </li>
          );
        })}
      </ol>
    </div>
  );
};
